/**
 * Configuración global de mutations
 */
export const ON_ROUTE = "ON_ROUTE";
export const ON_GET_CA = "ON_GET_CA";
export const ON_IS_LOADING = "ON_IS_LOADING";
export const ON_LANDING = "ON_LANDING";
export const ON_PASO_1 = "ON_PASO_1";
export const ON_PASO_1_SUCCESS = "ON_PASO_1_SUCCESS";
export const ON_PASO_2 = "ON_PASO_2";
export const ON_PASO_2_SUCCESS = "ON_PASO_2_SUCCESS";
export const ON_PASO_3 = "ON_PASO_3";
export const ON_PASO_4 = "ON_PASO_4";
export const ON_PASO_4_SUCCESS = "ON_PASO_4_SUCCESS";
export const ON_GRACIAS = "ON_GRACIAS";
export const ADOBE_APP_STARTED = "ADOBE_APP_STARTED";
export const ADOBE_APP_ON_CLICK_START = "ADOBE_APP_ON_CLICK_START";
export const ADOBE_ABRIR_CUENTA = "ADOBE_ABRIR_CUENTA";
export const ADOBE_INTERNAL_LINK = "ADOBE_INTERNAL_LINK";
export const ADOBE_PAGEVIEW = "ADOBE_PAGEVIEW";
export const ON_IS_EXCEEDED = "ON_IS_EXCEEDED";
export const ON_MOCK = "ON_MOCK";
export const ON_ADOBE_TARGET_EXPERIENCE = "ON_ADOBE_TARGET_EXPERIENCE";

/** Reactivo Web */
export const ON_REACTIVO_PASO1 = "ON_REACTIVO_PASO1";
export const ON_REACTIVO_OFERTA = "ON_REACTIVO_OFERTA";
export const ON_REACTIVO_EXCEDIDO = "ON_REACTIVO_EXCEDIDO";
export const ON_CONFIRMACION_SUCURSAL = "ON_CONFIRMACION_SUCURSAL";

/** Agro **/
export const ON_VALIDAR_CUIT_AGRO = "ON_VALIDAR_CUIT_AGRO";
export const ON_AGRO_ES_CLIENTE = "ON_AGRO_ES_CLIENTE";
export const ON_OFERTA_AGRO = "ON_OFERTA_AGRO";
export const ON_GENERAR_OTP_SUCCESS = "ON_GENERAR_OTP_SUCCESS";
export const SET_AGRO_DATA_FIELD = "SET_AGRO_DATA_FIELD";
export const SET_TELEFONO_VERIFICACION = "SET_TELEFONO_VERIFICACION";
export const SET_EMAIL_VERIFICACION = "SET_EMAIL_VERIFICACION";
export const SET_AGRO_ERROR = "SET_AGRO_ERROR";
export const CLEAR_AGRO_ERROR = "CLEAR_AGRO_ERROR";
